import type {LocalizationContextType} from 'localization/context/types';
import type {Part, Schema} from 'schemaDefinition/types';
import {getFieldRootKeys} from './getFieldRootKeys';
import {getFieldString} from './getFieldString';

export const getBoxLabel = (
  localization: LocalizationContextType,
  {key, name}: Pick<Part, 'key' | 'name'>,
  schema: Schema,
): string | undefined => {
  const rootKeys = getFieldRootKeys(schema.key, false, key, name);
  return getFieldString(rootKeys, false, '.label.box', localization);
};
